import React from 'react';
import { Link } from 'react-router-dom';
import { translateKeyLang } from '../../../../common/src/translate/translateHelper';
import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchGet, fetchPost } from '../../store/fetch';
import { Roles } from '../../utils/enums/Roles';
import { IRouterProps } from '../../utils/IRouterProps';
import { appContext } from '../appContext';
import { IconEditButton } from '../common/iconButtons/IconEditButton';
import {
    Content,
    EditPanelButton,
    EditPanelButtons,
    EditPanelCell,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    EditPanelSelect,
    EditPanelSwitch,
    Panel,
    PanelBody,
    PanelBodyHeading,
    PanelButtonLink,
    PanelWithoutForm,
    PopupElement,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumb,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { NullableBoolean } from '../utils/NullableBoolean';

interface IDefaultFailureModesProps extends ITranslateProps, IRouterProps {
    location: any;
}

interface IValueText {
    value: string;
    text: string;
}

interface IDefaultFailureMode {
    id?: undefined | string;
    name: string;
    isActive: boolean;
    clientCompanyId: string | null;
    clientCompany?:
        | undefined
        | {
              id: string;
              name: string;
          };
}

interface IDefaultFailureModestState extends IDefaultFailureMode {
    isSubmitting: boolean;
    isShowPopup: boolean;
    items: IDefaultFailureMode[];
    clientCompanies: IValueText[];
}

class DefaultFailureModesEdit extends React.Component<IDefaultFailureModesProps, IDefaultFailureModestState> {
    constructor(props: IDefaultFailureModesProps) {
        super(props);

        this.state = {
            isSubmitting: false,
            isShowPopup: false,
            items: [],
            clientCompanies: [],
            clientCompanyId: null,
            name: '',
            isActive: true,
        };
    }

    public override async componentDidMount() {
        await this.loadDefaultFailureModes();
        void this.loadClientCompanies();
    }

    public override render() {
        return (
            <appContext.Consumer>
                {(appState) => (
                    <>
                        <Topbar>
                            <TopbarLeft>
                                <TopbarCrumbActive
                                    title={`${translateKeyLang(appState.languageCode, 'failureMode.failureMode')} ${
                                        this.props.location.query.unitname
                                    }`}
                                    icon="fa-cogs"
                                />
                                <TopbarCrumb>
                                    <Link to="/settings/unitcodes">{this.props.t('common.units')}</Link>
                                </TopbarCrumb>
                            </TopbarLeft>
                            <TopbarRight>
                                <PanelButtonLink
                                    onClick={() => this.handleAddFailureModeClicked()}
                                    small={true}
                                    text={translateKeyLang(
                                        appState.languageCode,
                                        'common.addItem',
                                        translateKeyLang(appState.languageCode, 'failureMode.failureMode'),
                                    )}
                                    icon="fa fa-plus"
                                />
                            </TopbarRight>
                        </Topbar>

                        <Content>
                            <Tray>
                                <Panel>
                                    {(this.state.isSubmitting && <Spinner />) || (
                                        <PanelBody noPadding={true}>
                                            <Table>
                                                <TableHead>
                                                    <TableHeadRow light={true}>
                                                        <TableHeader>{translateKeyLang(appState.languageCode, 'common.name')}</TableHeader>
                                                        <TableHeader>{translateKeyLang(appState.languageCode, 'common.isActive')}</TableHeader>
                                                        {appState.userRole === Roles.Administrator && (
                                                            <>
                                                                <TableHeader>{this.props.t('common.company')}</TableHeader>
                                                            </>
                                                        )}
                                                        <TableHeader>&nbsp;</TableHeader>
                                                    </TableHeadRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.items &&
                                                        this.state.items.map((item) => (
                                                            <TableRow key={item.id}>
                                                                <TableData>{item.name}</TableData>
                                                                <TableData>
                                                                    <NullableBoolean value={item.isActive} useSymbols={true} />
                                                                </TableData>
                                                                {appState.userRole === Roles.Administrator && (
                                                                    <>
                                                                        <TableData>{item.clientCompany?.name}</TableData>
                                                                    </>
                                                                )}
                                                                <TableData alignRight={true}>
                                                                    <IconEditButton onClick={() => this.handleEditFailureModeClicked(item.id!)} />
                                                                </TableData>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </PanelBody>
                                    )}
                                    {this.state.isShowPopup && (
                                        <>
                                            <PopupElement onClick={() => this.setState({ isShowPopup: false })}>
                                                <form
                                                    method="post"
                                                    action="/"
                                                    id="admin-form"
                                                    onSubmit={async (e) => {
                                                        e.preventDefault();
                                                        await this.handleSaveFailureMode();
                                                    }}
                                                >
                                                    <PanelWithoutForm>
                                                        <PanelBodyHeading
                                                            text={translateKeyLang(
                                                                appState.languageCode,
                                                                'common.addItem',
                                                                translateKeyLang(appState.languageCode, 'failureMode.failureMode'),
                                                            )}
                                                        >
                                                            <EditPanelSection>
                                                                <EditPanelInput
                                                                    name="name"
                                                                    placeholder={translateKeyLang(appState.languageCode, 'failureMode.failureMode')}
                                                                    value={this.state.name}
                                                                    icon="fa fa-pagelines"
                                                                    handleChange={this.handleChange.bind(this)}
                                                                />
                                                            </EditPanelSection>
                                                            <EditPanelRow>
                                                                <EditPanelCell rowCount={6}>
                                                                    <EditPanelSwitch
                                                                        name="isActive"
                                                                        placeholder={translateKeyLang(appState.languageCode, 'common.isActive')}
                                                                        value={this.state.isActive}
                                                                        handleChange={this.handleChange.bind(this)}
                                                                    />
                                                                </EditPanelCell>
                                                                {appState.userRole === Roles.Administrator && (
                                                                    <EditPanelCell rowCount={6}>
                                                                        <EditPanelSelect
                                                                            name="clientCompanyId"
                                                                            placeholder={this.props.t(
                                                                                'common.selectItem',
                                                                                this.props.t('common.client'),
                                                                            )}
                                                                            value={this.state.clientCompanyId}
                                                                            handleChange={this.handleChange.bind(this)}
                                                                            options={this.state.clientCompanies}
                                                                        />
                                                                    </EditPanelCell>
                                                                )}
                                                            </EditPanelRow>
                                                            <EditPanelButtons>
                                                                <EditPanelButton
                                                                    onClick={this.handleCloseFormClicked.bind(this)}
                                                                    small={true}
                                                                    text={translateKeyLang(appState.languageCode, 'common.cancel')}
                                                                />
                                                                <EditPanelButton
                                                                    onClick={this.handleSaveFailureMode.bind(this)}
                                                                    small={true}
                                                                    primary={true}
                                                                    disabled={this.state.isSubmitting}
                                                                    text={translateKeyLang(
                                                                        appState.languageCode,
                                                                        'common.saveItem',
                                                                        translateKeyLang(appState.languageCode, 'failureMode.failureMode'),
                                                                    )}
                                                                />
                                                            </EditPanelButtons>
                                                        </PanelBodyHeading>
                                                    </PanelWithoutForm>
                                                </form>
                                            </PopupElement>
                                        </>
                                    )}
                                </Panel>
                            </Tray>
                        </Content>
                    </>
                )}
            </appContext.Consumer>
        );
    }

    private handleAddFailureModeClicked() {
        this.setState({
            isShowPopup: true,
            name: '',
            isActive: true,
            clientCompanyId: null,
            id: undefined,
        });
    }

    private handleCloseFormClicked() {
        this.setState({ isShowPopup: false });
    }

    private handleChange(value: any, stateKey: string) {
        if (stateKey === 'clientCompanyId' && value === '') {
            this.setState({ clientCompanyId: null });
        } else {
            const newState = {} as any;
            newState[stateKey] = value;
            this.setState(newState);
        }
    }

    private async handleSaveFailureMode() {
        this.setState({ isSubmitting: true });
        const data = {
            name: this.state.name,
            isActive: this.state.isActive,
            objectTypeUnitCodeId: this.props.match.params.id,
            clientCompanyId: this.state.clientCompanyId,
        } as any;

        let url = '/api/defaultFailureModes';
        if (this.state.id) {
            url += `/${this.state.id}`;
        }
        await fetchPost(url, {}, data);
        this.setState({ isShowPopup: false });
        await this.loadDefaultFailureModes();
    }

    private handleEditFailureModeClicked(selectedId: string) {
        for (let i = 0; i < this.state.items.length; i++) {
            const item = this.state.items[i]!;

            if (item.id === selectedId) {
                this.setState({
                    isShowPopup: true,
                    id: item.id,
                    name: item.name,
                    isActive: item.isActive,
                    clientCompanyId: item.clientCompany?.id ?? null,
                });
                break;
            }
        }
    }

    private async loadDefaultFailureModes() {
        const url = `/api/defaultFailureModes?objectTypeUnitCodeId=${this.props.match.params.id}&showAll=true`;
        const result = await fetchGet(url, {}, [], [403, 404]);
        this.setState({ items: result.json, isSubmitting: false });
    }

    private async loadClientCompanies() {
        const url = '/api/clients';
        const result = await fetchGet(url, {});
        const options = result.json.items.map((item: any) => ({ value: item.id, text: item.name }));
        this.setState({ clientCompanies: options });
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(DefaultFailureModesEdit);
